<template>
	<div
		ref="containerRef"
		:data-scrollable="scrollable"
		:data-scrollable-x="scrollableX"
		:data-scrollable-y="scrollableY"
		v-bind="simplebar ? {
			'data-simplebar': '',
			'data-simplebar-auto-hide': 'false'
		} : {}"
	>
		<slot></slot>
	</div>
</template>

<script setup>
import { ref, computed, onMounted, nextTick } from 'vue'
import { onResize } from "@js/throttle.js"

const props = defineProps({
	simplebar: {
		type: Boolean,
		default: false
	}
})

const scrollableX = ref(false)
const scrollableY = ref(false)
const containerRef = ref(null)

const checkIsScrollableX = (el) => {
	if (!el) return

	const hasScrollableContent = el.scrollWidth > el.clientWidth
	scrollableX.value = hasScrollableContent
}

const checkIsScrollableY = (el) => {
	if (!el) return

	const hasScrollableContent = el.scrollHeight > el.clientHeight
	scrollableY.value = hasScrollableContent
}

onMounted(async () => {
	await nextTick()
	const simplebarContentWrapper = props.simplebar
		? containerRef.value.querySelector('.simplebar-content-wrapper')
		: containerRef.value
	checkIsScrollableX(simplebarContentWrapper)
	checkIsScrollableY(simplebarContentWrapper)
})

onResize(async () => {
	await nextTick()
	const simplebarContentWrapper = props.simplebar
		? containerRef.value.querySelector('.simplebar-content-wrapper')
		: containerRef.value
	checkIsScrollableX(simplebarContentWrapper)
	checkIsScrollableY(simplebarContentWrapper)
});

const scrollable = computed(() => scrollableX.value || scrollableY.value)
</script>
